'use strict'

export default ({ type, locale, version }) => (type && locale && version)
  ? `${type}${locale && '/' + locale}${version && '/' + version}`
  : 'list'
